import { render, staticRenderFns } from "./TeachTeam.vue?vue&type=template&id=2cb450a6&scoped=true"
import script from "./TeachTeam.vue?vue&type=script&lang=js"
export * from "./TeachTeam.vue?vue&type=script&lang=js"
import style0 from "./TeachTeam.vue?vue&type=style&index=0&id=2cb450a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb450a6",
  null
  
)

export default component.exports